import { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

import ContactPanelForEditPopups from "../../TreatmentPage/components/ContactPanelForEditPopups";
import SelectStateModal from "../../TreatmentPage/modals/state-modal/SelectStateModal";

export const capitalize = (v) =>
  typeof v === "string" && v.length > 0 ? v.charAt(0).toUpperCase() + v.slice(1) : v;

export const registerCapitalized = (register, setValue, name, options = {}) => ({
  ...register(name, {
    ...options,
    onChange: (e) => {
      const v = e.target.value;
      if (v.length > 0) {
        setValue(name, capitalize(v), { shouldValidate: false, shouldDirty: true });
      }
      options.onChange?.(e);
    },
  }),
});

const PartyContactFields = ({ statesAbrs }) => {
  const { register, watch, setValue } = useFormContext();

  const [showStateDropdown, setShowStateDropdown] = useState(false);
  const handleStateShow = () => setShowStateDropdown((s) => !s);

  const homeState = watch("home_state");
  const homePhoneValue = watch("home_phone");
  const homeFaxValue = watch("home_fax");

  const dateField = {
    setValueAs: (v) => (v === "" || v === null ? null : v),
  };

  const formatPhone = (raw) => {
    const digits = (raw ?? "").replace(/\D/g, "").slice(0, 10);
    if (digits.length < 4) return digits;
    if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  };
  const handleHomePhoneInputChange = (e) => setValue("home_phone", formatPhone(e.target.value));
  const handleHomeFaxInputChange = (e) => setValue("home_fax", formatPhone(e.target.value));

  return (
    <Row className="mx-0 p-l-5 p-r-5 m-t-5">
      <ContactPanelForEditPopups
        pageName="OtherParties"
        name={`${watch("first_name") || ""}  ${watch("last_name") || ""}`}
        dynamic_label={"Full Name"}
        panel_name={"Contact Information"}
        phone_number={watch("home_phone")}
        fax_number={watch("home_fax")}
        email={watch("home_email")}
        address1={watch("home_address1")}
        address2={watch("home_address2")}
        city={watch("home_city")}
        state={watch("home_state")}
        zip_code={watch("home_zip")}
        ext={watch("home_extension")}
        websiteURL={watch("home_website")}
        buttonData={[]}
        genrate_doc_address={"Party Address"}
      />

      <Col md="auto" className="p-0 d-flex-1">
        <Row className="align-items-center custom-margin-bottom mx-0">
          <Col md={12} className="p-0">
            <div className="row mx-0 align-items-center custom-margin-bottom">
              <div className="d-flex-1 p-r-5">
                <input
                  type="text"
                  placeholder="First Name"
                  className="form-control rounded-0 height-25"
                  {...registerCapitalized(register, setValue, "first_name")}
                />
              </div>
              <div className="d-flex-1 p-r-5">
                <input
                  type="text"
                  placeholder="Middle Name"
                  className="form-control rounded-0 height-25"
                  {...registerCapitalized(register, setValue, "middle_name")}
                />
              </div>
              <div className="d-flex-1">
                <input
                  type="text"
                  placeholder="Last Name"
                  className="form-control rounded-0 height-25"
                  {...registerCapitalized(register, setValue, "last_name")}
                />
              </div>
            </div>

            <div className="row mx-0 align-items-center custom-margin-bottom">
              <div className="d-flex-1 p-r-5">
                <input
                  type="text"
                  placeholder="Address 1"
                  className="form-control rounded-0 height-25"
                  {...registerCapitalized(register, setValue, "home_address1")}
                />
              </div>
              <div className="d-flex-1">
                <input
                  type="text"
                  placeholder="Address 2"
                  className="form-control rounded-0 height-25"
                  {...registerCapitalized(register, setValue, "home_address2")}
                />
              </div>
            </div>

            <div className="row mx-0 align-items-center custom-margin-bottom">
              <div className="d-flex-1 p-l-0 p-r-5">
                <input
                  type="text"
                  placeholder="City"
                  className="form-control rounded-0 height-25"
                  {...registerCapitalized(register, setValue, "home_city")}
                />
              </div>
              <div
                className="d-flex-1 p-l-0 position-relative height-25 p-r-5 custom-select-new-provider"
                style={{ maxWidth: "90px" }}
              >
                <div
                  className="dropdown-button rounded-0 p-0 p-l-5 form-control height-25 d-flex align-items-center"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      handleStateShow();
                    }
                  }}
                  onClick={handleStateShow}
                >
                  <span id="selectedOption">
                    {homeState ? (
                      <div className="d-flex align-items-center">
                        <svg
                          style={{
                            width: "15px",
                            height: "15px",
                            fill: "var(--primary-80)",
                            color: "var(--primary-80)",
                            stroke: "var(--primary-80)",
                          }}
                          className={`icon icon-state-${homeState}`}
                        >
                          <use xlinkHref={`#icon-state-${homeState}`} />
                        </svg>
                        {homeState}
                      </div>
                    ) : (
                      "State"
                    )}
                  </span>
                </div>
              </div>
              <div className="d-flex-1 pe-0" style={{ maxWidth: "90px" }}>
                <input
                  type="text"
                  placeholder="Zip"
                  className="form-control rounded-0 height-25"
                  {...register("home_zip")}
                />
              </div>
            </div>

            <div className="row mx-0 align-items-center custom-margin-bottom">
              <div className="d-flex-1 p-r-5 p-l-0">
                <input
                  type="text"
                  placeholder="(###) ###-####"
                  className="form-control rounded-0 height-25"
                  {...register("home_phone")}
                  value={homePhoneValue || ""}
                  onChange={handleHomePhoneInputChange}
                />
              </div>
              <div className="d-flex-1" style={{ maxWidth: "90px" }}>
                <input
                  type="text"
                  placeholder="Ext"
                  className="form-control rounded-0 height-25"
                  {...register("home_extension", {
                    onChange: (e) => {
                      const sanitized = e.target.value.replace(/[^0-9]/g, "");
                      setValue("home_extension", sanitized);
                    },
                  })}
                />
              </div>
              <div className="d-flex-1 ps-1 pe-0">
                <input
                  type="text"
                  placeholder="(###) ###-####"
                  className="form-control rounded-0 height-25"
                  {...register("home_fax")}
                  value={homeFaxValue || ""}
                  onChange={handleHomeFaxInputChange}
                />
              </div>
            </div>

            <div className="row mx-0 align-items-center custom-margin-bottom">
              <div className="d-flex-1">
                <input
                  type="email"
                  placeholder="Email"
                  className="form-control rounded-0 height-25"
                  {...register("home_email")}
                />
              </div>
            </div>

            <div className="row mx-0 align-items-center custom-margin-bottom">
              <div className="d-flex-1">
                <input
                  type="text"
                  placeholder="Website"
                  className="form-control rounded-0 height-25"
                  {...register("home_website")}
                />
              </div>
            </div>

            <div className="row mx-0 align-items-center custom-margin-bottom">
              <span className="d-inline-block ps-0 white-space-nowrapping text-grey align-self-center m-r-5 defendant-input-label">
                Birthday:
              </span>
              <div className="d-flex-1">
                <input
                  type="date"
                  className="form-control p-l-5 p-0 height-25 rounded-0"
                  {...register("birthday", dateField)}
                />
              </div>
            </div>
          </Col>
        </Row>
      </Col>

      {showStateDropdown && (
        <SelectStateModal
          show={showStateDropdown}
          handleClose={handleStateShow}
          onChange={(data) => {
            setValue("home_state", data?.StateAbr);
          }}
          statesData={statesAbrs}
        />
      )}
    </Row>
  );
};

export default PartyContactFields;
